import { createFeatureSelector, createSelector } from '@ngrx/store'
import { DashboardState } from '../state/dashboard.state'

const getDashboardState = createFeatureSelector<DashboardState>('dashboard')

export const getDashboardBankingInfo = () =>
  createSelector(getDashboardState, state => {
    return state?.dashboardInfo
  })
